/*
 * @Author: changyunxia
 * @Date: 2020-09-28 11:46
 * @LastEditors: changyunxia
 * @LastEditTime:2020-09-28 11:46
 * @Description: 会议室预定 接口
 * @FilePath: \src\api\Meeting.js
 */
// import request from '../utils/request'
import request from '@/utils/request'

// wechat/auth
export function WechatAuth(object, callback = function() {}) {
  return request({
    url: 'wechat/auth',
    method: 'get',
    params: object
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[C00.UserList] error: ' + ex)
  })
}
// 检索所有会议
export function GetMeeting(callback = function() {}) {
  return request({
    url: 'C05/GetMeeting',
    method: 'get',
    data: null
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[C05.GetMeeting] error: ' + ex)
  })
}
// request({ url: '/C00/UserList', params: { user_code: getUsercode() }})
// .then(function(response) {
//   self.opt_users = response.data
//   self.params.user_code = self.$store.getters.usercode
//   self.title_user = self.FormartTitleUser(self.params.user_code)
// })
// .catch(() => { this.loading = false })
// 检索所有人员
export function GetUserList(object, callback = function() {}) {
  return request({
    url: '/C00/UserList',
    method: 'get',
    params: object
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[C00.UserList] error: ' + ex)
  })
}
// 检索所有部门
export function GetDeptList(object, callback = function() {}) {
  return request({
    url: '/C00/DeptList',
    method: 'get',
    params: object
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[/C00/DeptList] error: ' + ex)
  })
}
// 提交会议室预定信息
export function InsertMeeting(object, callback = function() {}) {
  return request({
    url: 'C05/InsertMeeting',
    method: 'post',
    // cache: false,
    data: object
    // params: object
    // headers: {
    //   'Content-Type': 'application/json'
    // }
  }).then(
    res => {
      console.log(res)
      callback(res)
    }
  ).catch(function(ex) {
    console.log(ex)
    callback({
      code: -2
    })
    console.log('[C05.InsertMeeting] error: ' + ex)
  })
}
// 更新会议室信息
export function UpdateMeeting(object, callback = function() {}) {
  return request({
    url: 'C05/UpdateMeeting',
    method: 'post',
    // cache: false,
    data: object
    // params: object
    // headers: {
    //   'Content-Type': 'application/json'
    // }
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[C05.UpdateMeeting] error: ' + ex)
  })
}
// 检索我的会议列表
export function GetMyMeetingList(object, callback = function() {}) {
  return request({
    url: '/C05/GetMyMeeting',
    method: 'get',
    params: object
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[/C05/GetMyMeeting] error: ' + ex)
  })
}
// 删除我的会议
export function DelectMeeting(object, callback = function() {}) {
  return request({
    url: '/C05/DelectMeeting',
    method: 'post',
    // params: object
    data: object
  }).then(
    res => {
      callback(res)
    }
  ).catch(function(ex) {
    callback({
      code: -2
    })
    console.log('[/C05/GetMyMeeting] error: ' + ex)
  })
}
